import script from "./RFMDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./RFMDescription.vue?vue&type=script&setup=true&lang=ts"
/* custom blocks */
import block0 from "./RFMDescription.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__